import { Loader } from "shared/components/Loader";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { AutoLoadMoreOnScroll } from "shared/app/Notes/components/AutoLoadMoreOnScroll";
import {
  CustomButtonLinkScope,
  CustomButtonLinkTarget
} from "types/landlord/address";
import { getErrorMessage } from "utils/error";
import { targetLabel } from "./helpers";
import { TargetChecklistRow } from "./TargetChecklistRow";

export const CustomButtonLinkTargetsList = ({
  scope,
  visibleTargets,
  hasSearch,
  selectedIds,
  onToggle,
  isLoading,
  isError,
  error,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore
}: {
  scope: CustomButtonLinkScope;
  visibleTargets: CustomButtonLinkTarget[];
  hasSearch: boolean;
  selectedIds: Map<number, CustomButtonLinkTarget>;
  onToggle: (target: CustomButtonLinkTarget) => void;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const plural = targetLabel(2, scope, dictionary);

  if (isLoading)
    return (
      <div className="flex items-center justify-center py-10">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <p className="py-6 text-sm font-medium text-danger-500">
        Failed to load {plural}: {getErrorMessage(error)}
      </p>
    );

  if (visibleTargets.length === 0)
    return (
      <p className="py-6 text-sm text-content-400">
        {hasSearch
          ? `No ${plural} match your search.`
          : `There are no other ${plural} to apply the link to.`}
      </p>
    );

  return (
    <div className="min-h-0 flex-1 space-y-1 overflow-y-auto">
      {visibleTargets.map((target) => (
        <TargetChecklistRow
          checked={selectedIds.has(target.id)}
          key={target.id}
          onToggle={() => onToggle(target)}
          scope={scope}
          target={target}
        />
      ))}

      {isFetchingNextPage ? (
        <div className="flex items-center justify-center py-2">
          <Loader size={20} />
        </div>
      ) : null}

      <AutoLoadMoreOnScroll
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onLoadMore={onLoadMore}
      />
    </div>
  );
};
